export type WizardStep = {
  label: string;
};

type WizardStepHeaderProps = {
  steps: WizardStep[];
  currentStepIndex: number;
  onStepClick?: (displayIndex: number) => void;
};

export function WizardStepHeader({
  steps,
  currentStepIndex,
  onStepClick
}: WizardStepHeaderProps): React.ReactNode {
  return (
    <div className="flex items-center gap-2">
      {steps.map(({ label }, i) => {
        const isCurrent = i === currentStepIndex;
        const isPast = i < currentStepIndex;

        const circle = (
          <div
            className={`flex size-6 shrink-0 items-center justify-center rounded-full text-xs font-medium ${
              isCurrent
                ? 'bg-primary text-primary-foreground'
                : isPast
                  ? 'bg-primary/20 text-primary group-hover:bg-primary/30'
                  : 'bg-secondary text-muted-foreground'
            }`}
          >
            {i + 1}
          </div>
        );

        const labelEl = (
          <span
            className={`hidden text-sm sm:inline ${isCurrent ? 'font-medium text-foreground' : 'text-muted-foreground'}`}
          >
            {label}
          </span>
        );

        return (
          <div key={label} className="flex items-center gap-2">
            {isPast && onStepClick ? (
              <button
                type="button"
                onClick={() => {
                  onStepClick(i);
                }}
                className="group flex items-center gap-2"
              >
                {circle}
                {labelEl}
              </button>
            ) : (
              <div className="flex items-center gap-2">
                {circle}
                {labelEl}
              </div>
            )}
            {i < steps.length - 1 && <div className="h-px w-3 bg-border sm:w-6" />}
          </div>
        );
      })}
    </div>
  );
}
